import { Col, Divider, Row } from "antd";
import CustomNoData from "apps/Common/CustomNoData";
import AdvertListViewSkelton from "apps/Common/Skelton/AdvertListViewSkelton";
import RealStateListViewItem from "apps/RealState/Common/ListViewItem";
import React from "react";
import { useGetMyPortfolioAdverts } from "../ServerSideStates";



const ListItems = () => {

   const adverts = useGetMyPortfolioAdverts({
      PageSize: -1,
      IncludeProperties: [
        "User",
        "Store",
        "Currency",
        "Country",
        "City",
        "District",
        "Neighbourhood",
        "AdvertMedia",
        "AdvertMedia.Media",
        "AdvertContactType",
        "AdvertContactType.ContactType",
       
      ],
      SortProperty: "price",
      SortType: "asc",
    });
    //  "AdvertOptionAttr",
  return (
    <>
      <Row gutter={[0, 20]}>
      

        <Divider className="!w-full" />

        <Col span={24}>
          <Row justify="space-between" gutter={[40, 40]}>
            <AdvertListViewSkelton
              count={4}
              customGutter={[40, 40]}
              loading={adverts.isLoading || adverts.isFetching}
              
            >
              <>
                {adverts?.data?.data?.data?.length>0
                  ? adverts?.data?.data?.data
                     
                      .map((item: any, index: number) => {
                        return (
                          <React.Fragment key={index}>
                            <Col
                              xs={24}
                             
                              className="hover:cursor-pointer"
                            >
                              <RealStateListViewItem
                              pageType="portfolio"
                                item={item}
                                advertType={item.type===0?"realState":"vehicle"}
                              />
                            </Col>
                          </React.Fragment>
                        );
                      })
                  : <>
                  <CustomNoData/>
                  </>}
              </>
            </AdvertListViewSkelton>
          </Row>
        </Col>
      </Row>


    </>
  );
};

export default ListItems;
